<template>
  <div class="text-center h-screen">
    <div class="h-1/3"></div>
    <div>
      <null-icon></null-icon>
      <div class="pt-4 font-extrabold text-4xl uppercase">Page not found</div>
      <div class="cursor-pointer text-white mt-4">
        <router-link to="/dashboard" class="bg-nw-red hover:bg-red-600 rounded px-4 py-2"> Go Home </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import NullIcon from '../components/icons/NullIcon.vue'
export default {
  components: { NullIcon }
}
</script>
